<div class="container icssr-container" style="margin-top: 140px; margin-bottom: 20px;">
  <div class="row">
    <div class="col-12">
      <!-- Title Section -->
      <div class="sau-title"
        style="display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
        <h3 style="margin-bottom: 10px; font-size: 24px;">Advertisement for Research Position: ICSSR Funded Minor
          Research Project</h3>
        <p class="content-text"
          style="text-align: center; margin-bottom: 0; max-width: 900px; color: #333; font-size: 17px;">We are
          inviting applications from dedicated, motivated, and actively engaged candidates for the position of Research
          Assistant to join our research team. The selected candidate will play an active role in supporting the
          implementation, and execution of Minor Research Project.</p>
      </div>

      <!-- Main Advertisement Download -->
      <div style="text-align: center; margin: 20px 0;">
        <a href="assets/Advertisement (1).docx" target="_blank" class="download-btn primary-btn">
          <i class="material-icons">description</i> Download Full Advertisement
        </a>
      </div>

      <!-- Details Card -->
      <div class="info-card">
        <div class="text-center" style="margin-bottom: 20px;">
          <h4 style="color: #084078; font-weight: 700; margin-bottom: 5px; font-size: 20px;">Application Process</h4>
          <p class="content-text" style="margin-bottom: 0;">Interested and eligible candidates are invited to submit
            their application through registered post only.</p>
        </div>

        <hr style="border-top: 1px dashed #dce3e9; margin-bottom: 20px; margin-top: 0;">

        <div class="row">
          <!-- Format Section -->
          <div class="col-md-6" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: flex-start;">
              <div class="feature-icon" style="margin-right: 15px;">
                <i class="material-icons" style="color: #1976d2; font-size: 24px;">description</i>
              </div>
              <div>
                <h6 style="font-weight: 700; margin-bottom: 8px; font-size: 16px; color: #222;">Application Format</h6>
                <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                  <a href="assets/pdf/ICSSR_Research_Assistant_Application_Form_A4 (1).docx" target="_blank"
                    class="download-btn word-btn">
                    <i class="material-icons" style="font-size: 16px;">description</i> Word
                  </a>
                  <a href="assets/pdf/ICSSR_Research_Assistant_Application_Form_A4 (1).pdf" target="_blank"
                    class="download-btn pdf-btn">
                    <i class="material-icons" style="font-size: 16px;">picture_as_pdf</i> PDF
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Date Section -->
          <div class="col-md-6" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: flex-start;">
              <div class="feature-icon" style="margin-right: 15px;">
                <i class="material-icons" style="color: #d32f2f; font-size: 24px;">event_available</i>
              </div>
              <div>
                <h6 style="font-weight: 700; margin-bottom: 8px; font-size: 16px; color: #222;">Important Date</h6>
                <div
                  style="background: #ffebee; color: #d32f2f; padding: 4px 12px; border-radius: 6px; font-weight: 700; display: inline-block; font-size: 14px; border: 1px solid #ffcdd2;">
                  Last Date: 21-08-2026
                </div>
              </div>
            </div>
          </div>

          <!-- Address Section -->
          <div class="col-md-6" style="margin-bottom: 10px;">
            <div style="display: flex; align-items: flex-start;">
              <div class="feature-icon" style="margin-right: 15px;">
                <i class="material-icons" style="color: #f57c00; font-size: 24px;">location_on</i>
              </div>
              <div>
                <h6 style="font-weight: 700; margin-bottom: 5px; font-size: 16px; color: #222;">Postal Address</h6>
                <p class="content-text" style="margin-bottom: 0; font-size: 14px;">
                  <strong>Principal,</strong> Guru Nanak Khalsa College, Yamuna Nagar, 135001 (Haryana).
                </p>
              </div>
            </div>
          </div>

          <!-- Contact Section -->
          <div class="col-md-6">
            <div style="display: flex; align-items: flex-start;">
              <div class="feature-icon" style="margin-right: 15px;">
                <i class="material-icons" style="color: #388e3c; font-size: 24px;">support_agent</i>
              </div>
              <div>
                <h6 style="font-weight: 700; margin-bottom: 5px; font-size: 16px; color: #222;">Contact Person</h6>
                <p class="content-text" style="margin-bottom: 0; font-size: 14px;">
                  <strong>MRS. POONAM BHASIN</strong><br>
                  <i class="material-icons"
                    style="font-size: 14px; vertical-align: middle; color: #666; margin-right: 4px;">call</i>+91
                  9896311661
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="text-muted" style="font-size: 13px; padding-top: 15px; text-align: center; margin-bottom: 0;">Published
        on 31st July, 2026</p>
    </div>
  </div>
</div>